module.exports = __webpack_public_path__ + "img/footer_dizhi.80a97fed.png";